export const environment = {
  production: true,
  //Servidor proprio local
  baseUrlApi: 'https://apiv1.webermaq.com/',
  //Hostgator
  //baseUrlApi: 'https://apiv1.webermaq.com/',
  //Local
  // baseUrlApi: 'http://127.0.0.1:8000/',
  apiTokenKey: 'apitoken'
};